import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Dialog, EntityFormRoot, TextArea } from '@lbcamden/lib-react';

export const noteFieldStyles = css`
  ${TextArea} {
    min-height: 5rem;
  }
`;

export const ResidentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
  width: 100%;
  margin: ${({ theme }) => theme.spacing([4, 0])};
`;

export const CurrentResidentsDialog = styled(Dialog)`
  ${({ theme }) => theme.breakpoints.up('md')} {
    max-height: 85vh;
  }
`;

export const DialogContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
  overflow: auto;

  ${EntityFormRoot} {
    overflow: initial;
  }
`;
